import { PaymentMethodType } from '../types'
import { WithdrawFeesAnMinActions } from './actions'
import * as AT from './actionTypes'

export type PaymentMethodWithdrawFeesAnMinData = Partial<
  Record<string, { fee?: number; gross?: number; min?: number }>
>
type PaymentMethodWithdrawFeesAnMinState = {
  readonly data?: PaymentMethodWithdrawFeesAnMinData
  readonly fetching: boolean
}

export type WithdrawFeesAnMinState = Partial<
  Record<PaymentMethodType | 'ALL', PaymentMethodWithdrawFeesAnMinState>
>

export const INITIAL_STATE: WithdrawFeesAnMinState = {}
const PAYMENT_METHOD_INITIAL_STATE = {
  fetching: false
}

const paymentMethodWithdrawFeesAndMinReducer = (
  state: PaymentMethodWithdrawFeesAnMinState = PAYMENT_METHOD_INITIAL_STATE,
  action: WithdrawFeesAnMinActions
) => {
  switch (action.type) {
    case AT.FETCH_SUCCESS:
      return { ...state, data: action.payload.data }
    case AT.FETCH:
      return { ...state, fetching: true }
    default:
      return state
  }
  return state
}

const withdrawFeesAndMinReducer = (
  state: WithdrawFeesAnMinState = INITIAL_STATE,
  action: WithdrawFeesAnMinActions
) => {
  if (!action) return state

  return {
    ...state,
    [action.payload.paymentMethod]: paymentMethodWithdrawFeesAndMinReducer(
      state[action.payload.paymentMethod],
      action
    )
  }
}

export default withdrawFeesAndMinReducer
